export const aNamed = "a-named";



// WEBPACK FOOTER //
// ./src/mod.js